export default "/dist/main.build.css";